import { Template } from "./template";

export class Plan {
    public id: number;
    public name: string;
    public number: string;
    public communityId: number;
    public productType: string;
    public isRTP: boolean;
    public templates: Template[];
}